// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { GameDataHandler } from "../game/GameDataHandler";
import { LevelNameValues } from "../game/level/levels/level";
/* END-USER-IMPORTS */

export default class LevelButton extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // starHolder
    const starHolder = scene.add.container(0, 0);
    this.add(starHolder);

    // starLine
    const starLine = scene.add.image(-1, 62, "level-select", "star-line.png");
    starHolder.add(starLine);

    // star1
    const star1 = scene.add.image(-32, 42, "level-select", "star-blue.png");
    starHolder.add(star1);

    // star2
    const star2 = scene.add.image(0, 42, "level-select", "star-blue.png");
    starHolder.add(star2);

    // star3
    const star3 = scene.add.image(32, 42, "level-select", "star-blue.png");
    starHolder.add(star3);

    // bg
    const bg = scene.add.image(0, 0, "level-select", "box-villain.png");
    this.add(bg);

    // fill
    const fill = scene.add.image(0, 0, "level-select", "box-villain-fill.png");
    this.add(fill);

    // icon
    const icon = scene.add.image(0, 0, "level-select", "icon-villain-prank.png");
    this.add(icon);

    // lists
    const stars = [star1, star2, star3];

    this.starHolder = starHolder;
    this.starLine = starLine;
    this.bg = bg;
    this.icon = icon;
    this.stars = stars;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.collectedStars = 0;
    this.targetScale = this.scaleY;
    /* END-USER-CTR-CODE */
  }

  private starHolder: Phaser.GameObjects.Container;
  private starLine: Phaser.GameObjects.Image;
  private bg: Phaser.GameObjects.Image;
  private icon: Phaser.GameObjects.Image;
  private stars: Phaser.GameObjects.Image[];
  public levelNum: number = 0;
  public litStarTexture: {key:string,frame?:string|number} = {"key":"level-select","frame":"star-gold.png"};
  public unlitStarTexture: {key:string,frame?:string|number} = {"key":"level-select","frame":"star-blue.png"};

  /* START-USER-CODE */
  public static events = {
    LevelSelected: 'levelSelected'
  } as const;

  protected collectedStars: number;
  protected targetScale: number;

  get CollectedStars(): number {
    return this.collectedStars;
  }

  get TargetScale(): number {
    return this.targetScale;
  }

  public awake() {
    this.updateCollectedStars();
    this.bindInput();
    this.targetScale = this.scaleY;
  }

  public setIcon(image: string) {
    this.icon.setFrame(image + '.png');
  }

  public tintButton(colour: number) {
    this.bg.tint = colour;
    this.starLine.tint = colour;
  }

  public activate() {
    this.showStars();
  }

  public select(colour: number) {
    this.tintButton(colour);
    this.startSelectedAnimation();
  }

  public unselect(colour: number) {
    this.tintButton(colour);
    this.stopSelectedAnimation();
  }

  protected bindInput() {
    this.setInteractive(
      new Phaser.Geom.Rectangle(0 - this.bg.displayWidth / 2, 0 - this.bg.displayHeight / 2, this.bg.displayWidth, this.bg.displayHeight),
      Phaser.Geom.Rectangle.Contains
    );

    this.on(Phaser.Input.Events.POINTER_DOWN, () => {});

    this.on(Phaser.Input.Events.POINTER_UP, () => {
      this.onPressed();
    });

    this.on(Phaser.Input.Events.POINTER_OUT, () => {});
  }

  protected showStars() {
    if(this.canShowStars())
    {
      this.scene.add.tween({
        targets: [this.starHolder],
        y: 35,
        duration: 500,
        ease: Phaser.Math.Easing.Cubic.Out
      });

      const delay = 100;
      for (const [index, star] of this.stars.entries()) {
        if (this.unlitStarTexture.frame) star.setFrame(this.unlitStarTexture.frame);
        star.scaleX = star.scaleY = 0;
        this.scene.add.tween({
          targets: star,
          scaleX: 1.5,
          scaleY: 1.5,
          duration: 100 + delay * index,
          ease: Phaser.Math.Easing.Cubic.Out,
          delay: 250,
          onComplete: () => {
            if (index < this.collectedStars && this.litStarTexture.frame) star.setFrame(this.litStarTexture.frame);
          }
        });

        this.scene.add.tween({
          targets: star,
          scaleX: 1,
          scaleY: 1,
          duration: 100 + delay * index,
          ease: Phaser.Math.Easing.Cubic.Out,
          delay: 250 + 100 + delay * index
        });
      }
    }
    else
    {
      this.starHolder.y = 0;
    }
  }

  protected hideStars() {
    this.scene.add.tween({
      targets: [this.starHolder],
      y: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  protected startSelectedAnimation() {
    this.scene.add.tween({
      targets: this.icon,
      scaleX: 1.1,
      scaleY: 1.1,
      duration: 750,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      yoyo: true,
      repeat: -1,
      delay: 750,
    });
  }

  protected stopSelectedAnimation() {
    this.scene.tweens.killTweensOf(this.icon);

    this.scene.add.tween({
      targets: this.icon,
      scaleX: 1,
      scaleY: 1,
      duration: 100,
      ease: Phaser.Math.Easing.Cubic.Out,
      yoyo: true
    });
  }

  protected updateCollectedStars() {
    // this.collectedStars = 2;
    let level = ('level' + (this.levelNum + 1)) as LevelNameValues;
    this.collectedStars = GameDataHandler.getStarScore(this.scene, level);
  }

  public canShowStars()
  {
    return this.collectedStars > 0;
  }

  protected onPressed() {
    this.emit(LevelButton.events.LevelSelected, this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
